import { Flex, Text } from '@chakra-ui/react'

import { phoneColorKeys } from './componentStyles/_colors'

const { WebPhonePage: PageColors } = phoneColorKeys.Phone

interface StatusDisplayProps {
  currentCustomStatus:
    | {
        availability: string
        label: string
      }
    | undefined
  formattedTime: string | undefined
}

export const StatusDisplay = ({
  currentCustomStatus,
  formattedTime,
}: StatusDisplayProps) => {
  if (!currentCustomStatus || currentCustomStatus.availability !== 'Away') {
    return null
  }

  return (
    <Flex
      w={'full'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      gap={'0.5rem'}
      borderRadius={'0.5rem'}
      border={'1px solid #E5E5EE'}
      bg={PageColors.AwayStatus}
      margin={'0.25rem'}
    >
      <Text
        color={'#000'}
        fontWeight={300}
        fontSize={{ base: '5rem', md: '8rem', lg: '10rem' }}
        lineHeight={{ base: '5rem', md: '8rem', lg: '10rem' }}
        width={{ base: '20rem', md: '40rem', lg: '50rem' }}
        textAlign={'center'}
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {formattedTime}
      </Text>
      <Text
        color={'#000'}
        fontWeight={800}
        fontSize={'2rem'}
        lineHeight={'2.5rem'}
      >
        {'Away - ' + currentCustomStatus.label}
      </Text>
    </Flex>
  )
}
